{
  "key": "cluster_test",
  "display": true,
  "format": "wkt",
  "dbs": "NEON",
  "table": "test.scratch",
  "srid": "3857",
  "geom": "geom_3857",
  "qID": "id",
  "cluster": {
    "distance": 30
  },
  "infoj": [
    {
      "type": "pin",
      "label": "ST_PointOnSurface",
      "field": "pin",
      "fieldfx": "ARRAY[ST_X(ST_PointOnSurface(geom_3857)),ST_Y(ST_PointOnSurface(geom_3857))]"
    }
  ],
  "style": {
    "default": {
      "icon": {
        "type": "dot",
        "fillColor": "#13336B"
      }
    },
    "cluster": {
      "icon": {
        "type": "target",
        "fillColor": "#E6FFFF",
        "layers": {
          "1": "#13336B",
          "0.85": "#E6FFFF"
        }
      }
    },
    "highlight": {
      "scale": 1.3
    },
    "theme": {
      "title": "theme_1",
      "type": "graduated",
      "field": "test_template_style",
      "graduated_breaks": "greater_than",
      "template": {
        "key": "test_template_style",
        "template": "100-99",
        "value_only": true
      },
      "cat_arr": [
        {
          "value": 0,
          "label": "0 to 5%",
          "style": {
            "icon": {
              "fillColor": "#ffffcc",
              "fillOpacity": 0.8
            }
          }
        }
      ]
    }
  }
}
